import React from 'react'

import img1 from './img/dabski1.jpg'
import img2 from './img/dabski1.jpg'
import img3 from './img/dabski1.jpg'

function opisWisla() {
  return (
    <div className='opis-container'>
      <div className='opis-header'>
        
        <h1>Grębałowianka - Wisła</h1> 
        
       
      </div>

      <div className='opis-info'>
          <p>
          4 kolejka I ligi oldboyów Kraków  <br></br>

Cracovia Kraków -Grębałowianka Kraków 5:1 (1:0) <br></br>
Bramka dla Gręby:Poplatek 

Skład Grębałowianki: Kokosza - Poplatek, Dominik, Korcala, Wierzbinski, Karaś, Oleś, Strojek G, Lampart, Mucharski, Strojek R,- Grzywa, Talaga, Zięba, Kawula, Franaszek 
Trener: Bernard Łach  <br></br>

1 kolejka przyniosła nam wyjazd do Pasów. Mecz z wymagającym rywalem zaczęliśmy bardzo uważnie zabezpieczając tyły i wyprowadzając mądre kontry. Pojedynek był bardzo wyrównany a swoje sytuacje mieli Lampart (słupek), Zięba (poprzeczka)jak również Mucharski i Oleś. Gospodarze również mieli swoje sytuacje po których jedna wpadła do bramki i pierwsza połowa zakończyła się rezultatem 1:0 dla Cracovii. 
Po zmianie stron pasy naciskały coraz bardziej (między słupkami bardzo dobre zawody rozegrał bramkarz Kokosza) a Gręba starała się za wszelką cenę wyrównać wynik meczu mając znowu sporo sytuacji bramkowych. Na bramkę strzelali Mucharski, Talaga, Oleś, Strojek niestety piłka jak zaczarowana nie chciała wpaść do sieci. Niestety gdy goście się otwarli za bardzo gospodarze wykorzystali nasze luki i strzelili kolejne bramki do wyniku 4:0. Pod koniec spotkania ładną akcję wykończył Poplatek strzelając honorową bramkę. Wynik na koniec ustaliły pasy na 5:1. 
Mecz ten dziś pokazał jak piłka potrafi być niesprawiedliwa gdyż goście zagrali naprawdę dobry mecz i z przebiegu zasłużyli na remis ale cóż co w sieci się liczy. 
Głowy do góry. Podziękowania dla wszystkich obecnych za przybycie i walkę do samego końca.
Za tydzień 2 kolejka gramy u siebie z Dąbskim Kraków 15.04. o 17:30 zapraszamy.


Pozdrawiam Piotr Grzywa 😉👌⚽
          
          </p>

        <img src={img1} alt='gre-dab'></img>
        <img src={img2} alt='gre-dab'></img>
        <img src={img3} alt='gre-dab'></img>
        
       
      </div>
        
        </div>
  )
}

export default opisWisla